import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import NavRail from './NavRail';
import { useWorkspaceStore } from '../../state/workspaceStore';
import { WORKSPACES } from '../../routes/workspaces';

const FULL_BLEED_PATHS = ['/public/ai'];

export default function PublicLayout() {
  const location = useLocation();
  const setLastVisited = useWorkspaceStore((s) => s.setLastVisited);
  const isFullBleed = FULL_BLEED_PATHS.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'));

  useEffect(() => {
    useWorkspaceStore.getState().setWorkspace(WORKSPACES.PUBLIC);
  }, []);

  useEffect(() => {
    setLastVisited(WORKSPACES.PUBLIC, location.pathname);
  }, [location.pathname, setLastVisited]);

  return (
    <div className="flex min-h-[calc(100vh-3rem)]">
      <Toaster richColors closeButton position="top-right" />
      <NavRail />
      {isFullBleed ? (
        <main
          className="flex-1 md:ml-16 animate-fade-in"
          style={{ height: 'calc(100vh - 3rem)', overflow: 'hidden' }}
        >
          <Outlet />
        </main>
      ) : (
        <main
          className="flex-1 md:ml-16 overflow-auto animate-fade-in"
          style={{ height: 'calc(100vh - 3rem)' }}
        >
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4 md:py-6 pb-20 md:pb-6">
            <Outlet />
          </div>
        </main>
      )}
    </div>
  );
}
